/**
 * Every Likely to Fill string, in one place so a copy change is a one-file edit.
 *
 * Follows the Crabs Figma page "Likely to fill updates", word for word what the
 * dental portal and the app show (GOTU-19796 / GOTU-19795); keep them matching.
 */

export const TREATMENT_LABELS = {
  veryLikely: 'Very Likely to Fill',
  likely: 'Likely to fill.',
  lessLikely: 'Less likely to fill',
  warning: 'Less likely to fill',
  unlikely: 'Unlikely to fill',
};

// `amount` is the first whole-dollar shortfall past the band above, e.g. "$4+".
export const TREATMENT_MESSAGES = {
  warning: (amount) => `This rate is ${amount} below market, so fewer professionals will apply.`,
  unlikely: (amount) =>
    `At ${amount} below market, this shift will rarely get professionals to apply.`,
};
